import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { AlertEvent } from './alert-types'

export const ALERT_BUFFER_MAX = 5000

export interface AlertState {
  events: AlertEvent[]
}

const initialState: AlertState = { events: [] }

function cap(events: AlertEvent[]): AlertEvent[] {
  return events.length > ALERT_BUFFER_MAX ? events.slice(0, ALERT_BUFFER_MAX) : events
}

export const alertSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    append(state, action: PayloadAction<AlertEvent>) {
      state.events = cap([action.payload, ...state.events])
    },
    appendMany(state, action: PayloadAction<AlertEvent[]>) {
      const incoming = [...action.payload].sort((a, b) => b.ts - a.ts)
      state.events = cap([...incoming, ...state.events])
    },
    clear(state) {
      state.events = []
    },
    clearScan(state, action: PayloadAction<string>) {
      state.events = state.events.filter((e) => e.scanId !== action.payload)
    },
  },
})

export const alertReducer = alertSlice.reducer
